// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared post-payment flow shell — aligned with ref-landing-page/steps.html */

.adhoc-flow {
  --flow-ink: #0F2A33;
  --flow-ink-soft: #4B6B72;
  --flow-paper: #F6FAF9;
  --flow-card: #FFFFFF;
  --flow-line: #DCEAE7;
  --flow-teal: #12A594;
  --flow-teal-deep: #0B3B4F;
  --flow-amber: #C7791B;
  --flow-amber-bg: #FBF1E1;
  --flow-grad: linear-gradient(120deg, #0B3B4F 0%, #12A594 55%, #34C77B 100%);
  --flow-shadow: 0 20px 50px -20px rgba(11, 59, 79, 0.25);
  --flow-font-display: 'Space Grotesk', 'Bricolage Grotesque', sans-serif;
  --flow-font-body: 'Inter', sans-serif;
  --flow-font-mono: 'IBM Plex Mono', monospace;

  max-width: 560px;
  margin: 0 auto;
  min-height: 100dvh;
  background: var(--flow-card);
  box-shadow: var(--flow-shadow);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  color: var(--flow-ink);
  font-family: var(--flow-font-body);
  -webkit-font-smoothing: antialiased;
}

.adhoc-flow * {
  box-sizing: border-box;
}

.adhoc-flow .flow-rail {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 22px 28px 0;
}

.adhoc-flow .flow-rail .seg {
  flex: 1;
  height: 3px;
  border-radius: 3px;
  background: var(--flow-line);
  overflow: hidden;
}

.adhoc-flow .flow-rail .seg span {
  display: block;
  height: 100%;
  width: 0%;
  background: var(--flow-grad);
  transition: width 0.5s ease;
}

.adhoc-flow .flow-rail .seg.done span,
.adhoc-flow .flow-rail .seg.active span {
  width: 100%;
}

.adhoc-flow .flow-rail-label {
  padding: 10px 28px 0;
  font-family: var(--flow-font-mono);
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--flow-ink-soft);
}

.adhoc-flow .flow-screen {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 20px 28px 32px;
  min-height: 0;
}

.adhoc-flow .flow-cta-row {
  margin-top: auto;
  padding-top: 22px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.adhoc-flow button.flow-primary {
  appearance: none;
  border: none;
  cursor: pointer;
  padding: 15px 20px;
  border-radius: 12px;
  background: var(--flow-grad);
  color: #fff;
  font-family: var(--flow-font-body);
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.01em;
  transition: opacity 0.2s, transform 0.2s;
}

.adhoc-flow button.flow-primary:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.adhoc-flow button.flow-primary:not(:disabled):hover {
  transform: translateY(-1px);
}

.adhoc-flow button.flow-ghost {
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
  padding: 8px;
  color: var(--flow-ink-soft);
  font-size: 13px;
  font-family: var(--flow-font-body);
}

.adhoc-flow .flow-error {
  margin-top: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #fffafa;
  border: 1px solid #fca5a5;
  color: #dc2626;
  font-size: 14px;
  line-height: 1.45;
}

/* Disclaimer screen */
.adhoc-flow .flow-legal-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: var(--flow-teal-deep);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
}

.adhoc-flow .flow-legal-icon svg {
  width: 24px;
  height: 24px;
  stroke: #fff;
}

.adhoc-flow .flow-title-legal {
  font-family: var(--flow-font-display);
  font-size: 22px;
  font-weight: 600;
  margin: 0 0 10px;
  letter-spacing: -0.01em;
}

.adhoc-flow .flow-legal-lede {
  font-size: 14.5px;
  line-height: 1.6;
  color: var(--flow-ink-soft);
  margin: 0 0 20px;
}

.adhoc-flow .flow-legal-card {
  border: 1px solid var(--flow-line);
  border-radius: 14px;
  background: var(--flow-paper);
  padding: 18px 18px 4px;
  flex: 1;
  overflow-y: auto;
  max-height: min(280px, 40dvh);
  min-height: 120px;
}

.adhoc-flow .flow-legal-card h4 {
  font-family: var(--flow-font-display);
  font-size: 12.5px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--flow-teal-deep);
  margin: 0 0 6px;
}

.adhoc-flow .flow-legal-card p {
  font-size: 13px;
  line-height: 1.6;
  color: var(--flow-ink);
  margin: 0 0 16px;
}

.adhoc-flow .flow-legal-card p:last-child {
  margin-bottom: 14px;
}

.adhoc-flow .flow-consent {
  margin-top: 18px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px 16px;
  border-radius: 12px;
  background: var(--flow-amber-bg);
  border: 1px solid #F0DDB4;
}

.adhoc-flow .flow-consent input {
  margin-top: 2px;
  width: 18px;
  height: 18px;
  accent-color: var(--flow-amber);
  flex-shrink: 0;
}

.adhoc-flow .flow-consent label {
  font-size: 13px;
  line-height: 1.5;
  color: #6B4A14;
  cursor: pointer;
}

/* Instructions screen */
@keyframes flow-breathe {
  0% { transform: scale(0.72); opacity: 0.32; }
  50% { transform: scale(1); opacity: 0.06; }
  100% { transform: scale(0.72); opacity: 0.32; }
}

.adhoc-flow .flow-instructions {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.adhoc-flow .flow-instructions-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 8px 0 4px;
  flex-shrink: 0;
}

.adhoc-flow .flow-ring-wrap {
  position: relative;
  width: 130px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
}

.adhoc-flow .flow-ring-pulse {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: var(--flow-grad);
  opacity: 0.18;
  animation: flow-breathe 4.2s ease-in-out infinite;
}

.adhoc-flow .flow-ring-pulse.delay {
  animation-delay: 1.4s;
}

.adhoc-flow .flow-ring-core {
  width: 84px;
  height: 84px;
  border-radius: 50%;
  background: var(--flow-grad);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 12px 30px -10px rgba(18, 165, 148, 0.55);
}

.adhoc-flow .flow-ring-core svg {
  width: 34px;
  height: 34px;
  stroke: #fff;
}

.adhoc-flow .flow-instructions-title {
  font-family: var(--flow-font-display);
  font-size: 22px;
  font-weight: 600;
  margin: 0 0 8px;
  letter-spacing: -0.01em;
}

.adhoc-flow .flow-instructions-lede {
  font-size: 14.5px;
  line-height: 1.55;
  color: var(--flow-ink-soft);
  margin: 0 0 6px;
  max-width: 400px;
}

.adhoc-flow .flow-timer-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  padding: 6px 14px;
  border-radius: 100px;
  background: var(--flow-amber-bg);
  color: var(--flow-amber);
  font-family: var(--flow-font-mono);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.02em;
}

.adhoc-flow .flow-timer-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--flow-amber);
}

.adhoc-flow .flow-instructions-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 16px;
}

.adhoc-flow .flow-prep-steps {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.adhoc-flow .flow-prep-step {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 14px 16px;
  border: 1px solid var(--flow-line);
  border-radius: 14px;
  background: var(--flow-paper);
}

.adhoc-flow .flow-prep-num {
  font-family: var(--flow-font-mono);
  font-size: 12px;
  font-weight: 500;
  color: var(--flow-teal);
  background: #E4F5F2;
  width: 26px;
  height: 26px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.adhoc-flow .flow-prep-text h3 {
  margin: 0 0 2px;
  font-family: var(--flow-font-display);
  font-size: 14.5px;
  font-weight: 600;
}

.adhoc-flow .flow-prep-text p {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: var(--flow-ink-soft);
}

.adhoc-flow .flow-instructions-footnote {
  margin-top: 18px;
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--flow-ink-soft);
  background: var(--flow-paper);
  border-left: 3px solid var(--flow-teal);
  padding: 10px 14px;
  border-radius: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/components/adhoc/flow.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E;EACE,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,2EAA2E;EAC3E,uDAAuD;EACvD,uEAAuE;EACvE,qCAAqC;EACrC,4CAA4C;;EAE5C,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,SAAS;EACT,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;EACtB,OAAO;EACP,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,KAAK,sBAAsB,EAAE,aAAa,EAAE;EAC5C,MAAM,mBAAmB,EAAE,aAAa,EAAE;EAC1C,OAAO,sBAAsB,EAAE,aAAa,EAAE;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;EAChC,wBAAwB;EACxB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":["/* Shared post-payment flow shell — aligned with ref-landing-page/steps.html */\n\n.adhoc-flow {\n  --flow-ink: #0F2A33;\n  --flow-ink-soft: #4B6B72;\n  --flow-paper: #F6FAF9;\n  --flow-card: #FFFFFF;\n  --flow-line: #DCEAE7;\n  --flow-teal: #12A594;\n  --flow-teal-deep: #0B3B4F;\n  --flow-amber: #C7791B;\n  --flow-amber-bg: #FBF1E1;\n  --flow-grad: linear-gradient(120deg, #0B3B4F 0%, #12A594 55%, #34C77B 100%);\n  --flow-shadow: 0 20px 50px -20px rgba(11, 59, 79, 0.25);\n  --flow-font-display: 'Space Grotesk', 'Bricolage Grotesque', sans-serif;\n  --flow-font-body: 'Inter', sans-serif;\n  --flow-font-mono: 'IBM Plex Mono', monospace;\n\n  max-width: 560px;\n  margin: 0 auto;\n  min-height: 100dvh;\n  background: var(--flow-card);\n  box-shadow: var(--flow-shadow);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  color: var(--flow-ink);\n  font-family: var(--flow-font-body);\n  -webkit-font-smoothing: antialiased;\n}\n\n.adhoc-flow * {\n  box-sizing: border-box;\n}\n\n.adhoc-flow .flow-rail {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 22px 28px 0;\n}\n\n.adhoc-flow .flow-rail .seg {\n  flex: 1;\n  height: 3px;\n  border-radius: 3px;\n  background: var(--flow-line);\n  overflow: hidden;\n}\n\n.adhoc-flow .flow-rail .seg span {\n  display: block;\n  height: 100%;\n  width: 0%;\n  background: var(--flow-grad);\n  transition: width 0.5s ease;\n}\n\n.adhoc-flow .flow-rail .seg.done span,\n.adhoc-flow .flow-rail .seg.active span {\n  width: 100%;\n}\n\n.adhoc-flow .flow-rail-label {\n  padding: 10px 28px 0;\n  font-family: var(--flow-font-mono);\n  font-size: 11px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--flow-ink-soft);\n}\n\n.adhoc-flow .flow-screen {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding: 20px 28px 32px;\n  min-height: 0;\n}\n\n.adhoc-flow .flow-cta-row {\n  margin-top: auto;\n  padding-top: 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.adhoc-flow button.flow-primary {\n  appearance: none;\n  border: none;\n  cursor: pointer;\n  padding: 15px 20px;\n  border-radius: 12px;\n  background: var(--flow-grad);\n  color: #fff;\n  font-family: var(--flow-font-body);\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  transition: opacity 0.2s, transform 0.2s;\n}\n\n.adhoc-flow button.flow-primary:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.adhoc-flow button.flow-primary:not(:disabled):hover {\n  transform: translateY(-1px);\n}\n\n.adhoc-flow button.flow-ghost {\n  appearance: none;\n  border: none;\n  background: none;\n  cursor: pointer;\n  padding: 8px;\n  color: var(--flow-ink-soft);\n  font-size: 13px;\n  font-family: var(--flow-font-body);\n}\n\n.adhoc-flow .flow-error {\n  margin-top: 12px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: #fffafa;\n  border: 1px solid #fca5a5;\n  color: #dc2626;\n  font-size: 14px;\n  line-height: 1.45;\n}\n\n/* Disclaimer screen */\n.adhoc-flow .flow-legal-icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  background: var(--flow-teal-deep);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 18px;\n}\n\n.adhoc-flow .flow-legal-icon svg {\n  width: 24px;\n  height: 24px;\n  stroke: #fff;\n}\n\n.adhoc-flow .flow-title-legal {\n  font-family: var(--flow-font-display);\n  font-size: 22px;\n  font-weight: 600;\n  margin: 0 0 10px;\n  letter-spacing: -0.01em;\n}\n\n.adhoc-flow .flow-legal-lede {\n  font-size: 14.5px;\n  line-height: 1.6;\n  color: var(--flow-ink-soft);\n  margin: 0 0 20px;\n}\n\n.adhoc-flow .flow-legal-card {\n  border: 1px solid var(--flow-line);\n  border-radius: 14px;\n  background: var(--flow-paper);\n  padding: 18px 18px 4px;\n  flex: 1;\n  overflow-y: auto;\n  max-height: min(280px, 40dvh);\n  min-height: 120px;\n}\n\n.adhoc-flow .flow-legal-card h4 {\n  font-family: var(--flow-font-display);\n  font-size: 12.5px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--flow-teal-deep);\n  margin: 0 0 6px;\n}\n\n.adhoc-flow .flow-legal-card p {\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--flow-ink);\n  margin: 0 0 16px;\n}\n\n.adhoc-flow .flow-legal-card p:last-child {\n  margin-bottom: 14px;\n}\n\n.adhoc-flow .flow-consent {\n  margin-top: 18px;\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  padding: 14px 16px;\n  border-radius: 12px;\n  background: var(--flow-amber-bg);\n  border: 1px solid #F0DDB4;\n}\n\n.adhoc-flow .flow-consent input {\n  margin-top: 2px;\n  width: 18px;\n  height: 18px;\n  accent-color: var(--flow-amber);\n  flex-shrink: 0;\n}\n\n.adhoc-flow .flow-consent label {\n  font-size: 13px;\n  line-height: 1.5;\n  color: #6B4A14;\n  cursor: pointer;\n}\n\n/* Instructions screen */\n@keyframes flow-breathe {\n  0% { transform: scale(0.72); opacity: 0.32; }\n  50% { transform: scale(1); opacity: 0.06; }\n  100% { transform: scale(0.72); opacity: 0.32; }\n}\n\n.adhoc-flow .flow-instructions {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.adhoc-flow .flow-instructions-hero {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 8px 0 4px;\n  flex-shrink: 0;\n}\n\n.adhoc-flow .flow-ring-wrap {\n  position: relative;\n  width: 130px;\n  height: 130px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 18px;\n}\n\n.adhoc-flow .flow-ring-pulse {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  background: var(--flow-grad);\n  opacity: 0.18;\n  animation: flow-breathe 4.2s ease-in-out infinite;\n}\n\n.adhoc-flow .flow-ring-pulse.delay {\n  animation-delay: 1.4s;\n}\n\n.adhoc-flow .flow-ring-core {\n  width: 84px;\n  height: 84px;\n  border-radius: 50%;\n  background: var(--flow-grad);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 12px 30px -10px rgba(18, 165, 148, 0.55);\n}\n\n.adhoc-flow .flow-ring-core svg {\n  width: 34px;\n  height: 34px;\n  stroke: #fff;\n}\n\n.adhoc-flow .flow-instructions-title {\n  font-family: var(--flow-font-display);\n  font-size: 22px;\n  font-weight: 600;\n  margin: 0 0 8px;\n  letter-spacing: -0.01em;\n}\n\n.adhoc-flow .flow-instructions-lede {\n  font-size: 14.5px;\n  line-height: 1.55;\n  color: var(--flow-ink-soft);\n  margin: 0 0 6px;\n  max-width: 400px;\n}\n\n.adhoc-flow .flow-timer-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 12px;\n  padding: 6px 14px;\n  border-radius: 100px;\n  background: var(--flow-amber-bg);\n  color: var(--flow-amber);\n  font-family: var(--flow-font-mono);\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n}\n\n.adhoc-flow .flow-timer-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--flow-amber);\n}\n\n.adhoc-flow .flow-instructions-scroll {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  margin-top: 16px;\n}\n\n.adhoc-flow .flow-prep-steps {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.adhoc-flow .flow-prep-step {\n  display: flex;\n  gap: 14px;\n  align-items: flex-start;\n  padding: 14px 16px;\n  border: 1px solid var(--flow-line);\n  border-radius: 14px;\n  background: var(--flow-paper);\n}\n\n.adhoc-flow .flow-prep-num {\n  font-family: var(--flow-font-mono);\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--flow-teal);\n  background: #E4F5F2;\n  width: 26px;\n  height: 26px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.adhoc-flow .flow-prep-text h3 {\n  margin: 0 0 2px;\n  font-family: var(--flow-font-display);\n  font-size: 14.5px;\n  font-weight: 600;\n}\n\n.adhoc-flow .flow-prep-text p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--flow-ink-soft);\n}\n\n.adhoc-flow .flow-instructions-footnote {\n  margin-top: 18px;\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: var(--flow-ink-soft);\n  background: var(--flow-paper);\n  border-left: 3px solid var(--flow-teal);\n  padding: 10px 14px;\n  border-radius: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
